<section class="entity">
    <header class="entityHeader">
        <div class="actions">
            @if (fieldsDirty()) {
                <lib-helper-info message="Unsaved changes"></lib-helper-info>
                <button class="secondary-btn" type="button" (click)="onCancelCustomFields()">Cancel</button>
                <button class="primary-btn" type="button" (click)="onSaveCustomFields()">Save</button>
            }
        </div>
        <div class="entityHeaderTitle">
            <span class="entityTitle">{{ entityName() }} Custom Fields</span>
            <div class="entityHeaderActions">
                @if (canAddNewField()) {
                    <button class="secondary-btn" type="button" (click)="addCustomField()">
                        <span class="icon" [innerHTML]="plusIcon"></span> New field
                    </button>
                }
            </div>
        </div>
    </header>

    <app-customization-filters
        [entityTypeId]="entityTypeId()"
        (filtersChange)="onFiltersChange($event)"
    ></app-customization-filters>

    <div class="entityGrid">
        @if (hasNoCustomFields()) {
            <div class="noData">
                <lib-no-data
                    [iconName]="'empty'"
                    [title]="'You don\'t have custom fields.'"
                    [text]="'Add a custom field to use as a variable.'"
                ></lib-no-data>
            </div>
        } @else {
            <article class="entityCard">
                <form [formGroup]="customFieldsForm">
                    <div
                        class="entityList"
                        formArrayName="fields"
                        cdkDropList
                        cdkDropListOrientation="vertical"
                        (cdkDropListDropped)="onFieldsDrop($event)"
                    >
                        @for (
                            field of customFieldsArray.controls;
                            track field.controls.id.value ?? $index;
                            let i = $index
                        ) {
                            @let fieldId = field.controls.id.value;
                            @let isReserved = field.controls.isReserved.value;
                            @let isActive = field.controls.isActive.value;
                            @let customFieldType = field.controls.customFieldType.value;
                            @let customFieldTypeId = customFieldType?.id ?? field.controls.customFieldTypeId.value;
                            @let isExistingField = fieldId !== null && fieldId !== undefined && fieldId > 0;
                            @let isListType =
                                customFieldTypeId === CustomFieldTypes.List ||
                                customFieldTypeId === CustomFieldTypes.MultipleSelectionList;

                            <div class="entityRow" [formGroupName]="i" cdkDrag>
                                <div class="wrapper" [class.locked]="isReserved">
                                    <div class="container">
                                        <div class="dragButton" cdkDragHandle aria-label="Reorder field">
                                            <button class="resetStyles dragIndicator" type="button">
                                                <span class="icon" [innerHTML]="dragIndicatorIcon"></span>
                                            </button>
                                        </div>

                                        <div class="body">
                                            <div class="fieldRow">
                                                <app-reactive-field-input
                                                    [label]="'Field Name'"
                                                    [control]="field.controls.name"
                                                    [placeholder]="'Add Field Name'"
                                                    [shouldTrimSpaces]="true"
                                                    [readonly]="isReserved"
                                                ></app-reactive-field-input>

                                                <app-reactive-field-input
                                                    [label]="'Description'"
                                                    [control]="field.controls.description"
                                                    [placeholder]="'Add Description'"
                                                    [readonly]="isReserved"
                                                ></app-reactive-field-input>

                                                <app-reactive-dropdown
                                                    [label]="'Type'"
                                                    [source]="customFieldTypes()"
                                                    [config]="{
                                                        defaultText: 'Select type',
                                                        itemDisplayKey: 'name',
                                                        multiple: false,
                                                        clearSelection: false
                                                    }"
                                                    [isReadOnly]="isExistingField || isReserved"
                                                    [formControl]="field.controls.customFieldType"
                                                ></app-reactive-dropdown>

                                                @if (isListType) {
                                                    <app-reactive-list-options
                                                        [label]="'List Options'"
                                                        [formControl]="field.controls.options"
                                                        [control]="field.controls.options"
                                                        [readonly]="isReserved"
                                                    ></app-reactive-list-options>
                                                }

                                                <app-reactive-dropdown
                                                    [label]="'Field Placement'"
                                                    [source]="entitySections()"
                                                    [config]="{
                                                        defaultText: 'Select Placement',
                                                        itemDisplayKey: 'name',
                                                        multiple: false,
                                                        clearSelection: false
                                                    }"
                                                    [formControl]="field.controls.entityTypeCustomFieldSection"
                                                    [isReadOnly]="isReserved"
                                                ></app-reactive-dropdown>
                                            </div>
                                        </div>

                                        <div class="actions" [class.iconLocked]="isReserved">
                                            @if (isReserved) {
                                                <div class="lockedIcon">
                                                    <span class="icon" [innerHTML]="lockedIcon"></span>
                                                </div>
                                            } @else if (!fieldsDirty()) {
                                                @if (isActive) {
                                                    <button
                                                        type="button"
                                                        class="resetStyles tooltipButton"
                                                        (click)="onToggleCondition(i, true)"
                                                        title="Archive"
                                                    >
                                                        <span class="icon" [innerHTML]="archiveIcon"></span>
                                                    </button>
                                                } @else {
                                                    <button
                                                        type="button"
                                                        class="resetStyles tooltipButton"
                                                        (click)="onToggleCondition(i, false)"
                                                        title="Restore"
                                                    >
                                                        <span class="icon" [innerHTML]="restoreIcon"></span>
                                                    </button>
                                                }
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </form>
            </article>
        }
    </div>
</section>
